'use client';

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';

export default function ProgressProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <ProgressBar height='3px' color='#3177FF' options={{ showSpinner: false }} shallowRouting />
    </>
  );
}
